<script>
import cloneDeep from 'lodash/cloneDeep'
import { nameListComputed, nameListMethods } from '@state/helpers/name-list'
import {
  memberRegistrationComputed,
  memberRegistrationMethods,
} from '@state/helpers/member-registration'
import { STATUS_REQUEST } from '@utils/constant'
import registrationItems from './registrationItems'

export default {
  page: {
    title: 'Registration Member',
    meta: [{ name: 'description', content: 'The Member Add new page.' }],
  },
  props: {
    pickerType: {
      type: String,
      default: '',
      require: false,
    },
  },
  data() {
    return {
      checkedList: [1],
      items: {},
      title: this.$t('pages.memberRegistration'),
      optionsGender: [
        {
          value: '1',
          label: '男性',
        },
        {
          value: '0',
          label: '女性',
        },
      ],
      optionsAthlele: [
        {
          value: '0',
          label: 'いいえ',
        },
        {
          value: '1',
          label: 'はい',
        },
      ],
    }
  },
  computed: {
    ...nameListComputed,
    ...memberRegistrationComputed,
    nameListComputed() {
      const options = cloneDeep(this.getNameList)
      return options?.list?.map((item, index) => {
        if (index === 0) {
          return { value: item.id, label: item.company, disabled: true }
        } else {
          return { value: item.id, label: item.company }
        }
      })
    },
    errorServerSideComputed() {
      return this.getErrors
    },
  },
  watch: {
    getStatus() {
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetRegistrationMember()
        this.backToListPage()
      }
    },
    nameListComputed() {
      this.items.map((item) => {
        if (item.key === 'agent_ids') {
          item.options = this.nameListComputed
          item.checked = [1]
        } else if (item.key === 'gender') {
          item.options = this.optionsGender
          item.checked = this.optionsGender[0].value.toString()
        } else if (item.key === 'athlete') {
          item.options = this.optionsAthlele
          item.checked = this.optionsAthlele[0].value.toString()
        }
      })
    },
  },
  created() {
    this.fetchingNameList()
  },
  mounted() {
    this.initItems()
  },
  methods: {
    ...memberRegistrationMethods,
    ...nameListMethods,
    initItems() {
      this.items = cloneDeep(registrationItems)
    },
    handleAddNewMember() {
      this.formatNumber()
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      this.registrationMember(payload)
    },
    handleUpdateCheckbox(field, value) {
      this.items.map((item) => {
        if (item.name === field) {
          item.value = [...value, 1]
        }
      })
      return this.items
    },
    handleUpdate(value) {
      this.items.map((item) => {
        if (item.name === 'birthday') {
          item.value = value
        }
      })
    },
    handleUpdateRadio(field, value) {
      this.items.map((item) => {
        if (item.name === field) {
          item.value = value
        }
      })
    },
    formatNumber() {
      this.items[7].value = parseInt(this.items[7].value)
      this.items[5].value = parseInt(this.items[5].value)
      this.items[8].value = parseInt(this.items[8].value)
      return this.items
    },
    handleCancel() {
      this.initItems()
      this.backToListPage()
    },
    backToListPage() {
      this.$router.push({ path: '/panel/member-list' })
    },
    isRequiredPassword(data) {
      return !(data.trim() === '' && data.length > 0)
    },
    isComfirmedPassword(key) {
      const field = {
        passwordConfirm: 4,
        password: 3,
      }
      if (this.items[field[key]].value === '') {
        return false
      } else {
        return key
      }
    },
  },
}
</script>

<template>
  <BaseAddNewCard
    :errors="errorServerSideComputed"
    type="add"
    @submit="handleAddNewMember"
    @cancel="handleCancel"
  >
    <template v-slot:header>
      <h5 class="card-title">{{ title }}</h5>
    </template>
    <template v-slot>
      <CRow v-for="item in items" :key="item.key">
        <CCol sm="3">
          {{ item.label }}
          <span v-if="item.rules" class="text-danger">*</span>
        </CCol>
        <CCol :sm="item.as === 'checkbox' ? 9 : 3">
          <BaseCheckboxGroup
            v-if="item.as === 'checkbox'"
            inline
            :rules="item.rules"
            :name="item.name"
            :options="item.options"
            :checked="item.checked"
            @update:checked="(v) => handleUpdateCheckbox(item.name, v)"
          />
          <BaseRadioGroup
            v-if="item.as === 'radio'"
            inline
            :rules="item.rules"
            :name="item.name"
            :options="item.options"
            :checked.sync="item.checked"
            custom
            @update:checked="(v) => handleUpdateRadio(item.name, v)"
          />
          <BaseDatePicker
            v-if="item.as === 'datepicker'"
            :picker-type="pickerType"
            :rules="item.rules"
            :init-date="item.value"
            @update:date="(v) => handleUpdate(v)"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
              confirmed: isComfirmedPassword('password'),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'email'"
            v-model="item.value"
            :rules="{ ...item.rules, ...{ required: item.value.length <= 0 } }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="off"
          />
          <BaseInput
            v-if="
              item.as === 'input' &&
                item.key !== 'password' &&
                item.key !== 'password_2' &&
                item.key !== 'email'
            "
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
        </CCol>
      </CRow>
    </template>
  </BaseAddNewCard>
</template>

<style lang="scss" scoped>
::v-deep .mx-datepicker[data-v-8d8a95e0] {
  width: 100%;
}
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
